import ADD_NEWS from "./addNews"
import ADD_NEWS_SOURCE from "./addNewsSource"
import ADD_OUTLET from "./addOutlet"
import ADD_PREVIEW_NEWS_SOURCE from "./addPreviewNewsSource"
import DELETE_NEWS from "./deleteNews"
import DELETE_OUTLET from "./deleteOutlet"
import GENERATE_DRAFT_NEWS from "./generateDraftNews"
import PUBLISH_DRAFT_NEWS from "./publishDraftNews"
import UPDATE_NEWS from "./updateNews"
import UPDATE_NEWS_SOURCE from "./updateNewsSource"
import UPDATE_NEWS_SOURCES_FROM_URL from "./updateNewsSourcesFromUrl"
import UPDATE_OUTLET from "./updateOutlet"

export default {
  ADD_NEWS,
  ADD_NEWS_SOURCE,
  ADD_OUTLET,
  ADD_PREVIEW_NEWS_SOURCE,
  DELETE_NEWS,
  DELETE_OUTLET,
  GENERATE_DRAFT_NEWS,
  PUBLISH_DRAFT_NEWS,
  UPDATE_NEWS,
  UPDATE_NEWS_SOURCE,
  UPDATE_NEWS_SOURCES_FROM_URL,
  UPDATE_OUTLET
}
